import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo, forwardRef } from "react";
import { useTextBasedInput } from "../hooks/useTextBasedInput.js";
import { useComponentClassName } from "../../../auxiliary/useComponentClassName.js";
import { toViewClass } from "../../../utils/toViewClass.js";
const SearchInput = memo(
  forwardRef(({
    className,
    withTopToolbar,
    ...outerProps
  }, forwardedRed) => {
    const props = useTextBasedInput({
      ...outerProps,
      className: classNames(
        useComponentClassName("text-input"),
        useComponentClassName("search-input"),
        toViewClass("withTopToolbar", withTopToolbar),
        className
      )
    }, forwardedRed);
    return /* @__PURE__ */ jsx(
      "input",
      {
        autoCorrect: "off",
        autoCapitalize: "off",
        autoComplete: "off",
        spellCheck: "false",
        ...props,
        type: "search"
      }
    );
  })
);
SearchInput.displayName = "SearchInput";
export {
  SearchInput
};
//# sourceMappingURL=SearchInput.js.map
